import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Override del token (es. sessione rete sulla scheda di costo della propria pratica).
let tokenOverride = null;
export const setApiTokenOverride = (t) => { tokenOverride = t || null; };

api.interceptors.request.use((config) => {
  const token = tokenOverride || localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Forza il logout sul dispositivo la cui sessione è stata invalidata da un nuovo accesso.
// NB: le pagine pubbliche (free/tetto, consulenze /c, outlook /p, configuratore, rete, mappa)
// NON devono buttare al login se una chiamata restituisce 401 (es. token scaduto in localStorage
// attaccato a un endpoint pubblico o a /auth/me al mount): gestiscono da sole gli errori.
const PUBLIC_PREFIXES = ["/free", "/c/", "/p/", "/configura", "/rete", "/mappa-installatori"];
const isPublicPath = (p) => PUBLIC_PREFIXES.some((pre) => p === pre || p.startsWith(pre));

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const hadToken = !!localStorage.getItem("token");
    const onLogin = window.location.pathname === "/login";
    if (status === 401 && hadToken && !onLogin && !isPublicPath(window.location.pathname)) {
      localStorage.removeItem("token");
      sessionStorage.setItem("session_ended", "1");
      window.location.assign("/login");
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  // Se viene passato direttamente l'oggetto errore Axios, estrai il messaggio reale del backend.
  if (detail?.isAxiosError || detail?.response) {
    const d = detail.response?.data?.detail ?? detail.response?.data?.message;
    if (d != null) return formatApiError(d);
    return "Si è verificato un errore. Riprova.";
  }
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}


// Indirizzo del cantiere del lead (stesso driver del backend resolve_cantiere_address)
export function cantiereAddress(lead) {
  if (!lead) return "";
  if (lead.indirizzo_impianto_diverso && (lead.indirizzo_impianto || "").trim()) return lead.indirizzo_impianto.trim();
  if ((lead.indirizzo_residenza || "").trim()) return lead.indirizzo_residenza.trim();
  return [lead.address, lead.city].filter(Boolean).join(", ").trim();
}

// Estrae il solo comune da una stringa indirizzo (indirizzi IT: il comune segue il civico)
function extractComune(raw) {
  if (!raw) return "";
  let s = String(raw).trim().replace(/,?\s*(italia|italy)\s*$/i, "").trim();
  // Se presente un numero civico, il comune è ciò che segue l'ultimo numero
  const nums = s.match(/\d+/g);
  if (nums) {
    const last = nums[nums.length - 1];
    const after = s.slice(s.lastIndexOf(last) + last.length);
    if (after.trim()) s = after;
  } else if (s.includes(",")) {
    s = s.split(",").pop();
  }
  // Pulisce virgole, CAP e sigla provincia residui
  return s.replace(/^[\s,]+/, "").replace(/\b\d{5}\b/g, "").replace(/\s*\(?[A-Z]{2}\)?\s*$/g, "").trim();
}

// Solo il comune del cantiere (PVGIS legge la località, non l'indirizzo completo)
export function cantiereComune(lead) {
  if (!lead) return "";
  const comune = extractComune(cantiereAddress(lead));
  if (comune) return comune;
  return extractComune(lead.city) || (lead.city || "").trim();
}
